"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.prototype.formatCity = function (city) {
        return city
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toUpperCase();
    };
    Utils.prototype.getCRC16 = function (payload) {
        var length = payload.length;
        // DADOS DEFINIDOS PELO BACEN
        var polinomio = 0x01021;
        var resultado = 0x0ffff;
        // CHECKSUM
        if (length > 0) {
            for (var offset = 0; offset < length; offset++) {
                resultado ^= payload[offset].charCodeAt(0) << 8;
                for (var bitwise = 0; bitwise < 8; bitwise++) {
                    if ((resultado <<= 1) & 0x010000)
                        resultado ^= polinomio;
                    resultado &= 0x0ffff;
                }
            }
        }
        else {
            return 'FFFF';
        }
        // RETORNA CÓDIGO CRC16 DE 4 CARACTERES
        return resultado.toString(16).toUpperCase().padStart(4, '0');
    };
    return Utils;
}());
var utils = new Utils();
exports.Utils = utils;
